import * as z from 'zod/mini';
import type { TranslatorFor } from '@//locales/messages';

// Swedish SSN regex
const swedishSSNRegex = /^(19|20)?\d{2}[01]\d[0-3]\d[-+]?\d{4}$/;

export const IfInsuranceSchema = (t: TranslatorFor<'utils.validation'>) =>
  z.object({
    socialId: z.string().check(
      // non-empty
      z.refine((s) => s.length >= 1, t('requiredSwedishSSN')),
      // matches SSN pattern
      z.refine((s) => swedishSSNRegex.test(s), t('requiredSwedishSSN')),
    ),
    drivingDistance: z.string(),
  });

type IfInsurance = z.infer<ReturnType<typeof IfInsuranceSchema>>;

export const getDefaultValues = (): IfInsurance => ({
  socialId: '',
  drivingDistance: '1',
});
